/**
 * helper function to wrap mutation call and return data
 * @param {object} values values to send
 * @param {func} func mutation function
 * @returns {object} {data (mixed): response, status (number): response status, isError (boolean)}
 */
const getMutationResult = async (values = {}, func = () => { }) => {
  const result = {
    data: {},
    status: 200,
    isError: false,
  };

  try {
    const payload = await func(values).unwrap();
    result.data = payload || {};
  } catch (err) {
    result.data = err.data || {};
    result.status = err.status || 500;
    result.isError = true;
  }

  return result;
};

export {
  getMutationResult,
};
